import React from 'react';
import DataTable from 'react-data-table-component';

import columns from './columns';

export default function Table({ enterpriseId, briefs, refresh }) {
  const onDelete = () => {
    refresh();
  };

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns({
          enterpriseId,
          onDelete,
        })}
        data={briefs || []}
        noDataComponent={(
          <div className="mt20">
            {briefs == null
              ? 'Please, wait ...'
              : 'No matching records found'}
          </div>
          )}
        persistTableHead
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: 'All',
        }}
      />
    </div>
  );
}
